import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ViewLayout, AdvanceStack, OtherLayout } from './components';
import { RibbonBar, RibbonDivider } from 'common/components';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import ProductHierarchy from './components/controls/product-full/ProductHierarchy';
import Subscription from './components/controls/product-full/Subscription';
import HistorySection from './components/sections/product/HistorySection';
import ProductDetailView from './components/controls/product-full/ProductDetailView';
import ActionsRibbonBar from 'common/components/contact-action/ActionsRibbonBar';
// import QASpecAssignSupplier from './components/controls/product-full/QASpecAssignSupplier';
// import QaEvaluationForm from './components/controls/product-full/QaEvaluationForm';
import ProductPackaging from './components/controls/product-full/ProductPackaging';

import HierarchyActions from './components/controls/product-full/HierarchyActions';
import ProductFullAction from './components/controls/product-full/ProductFullAction';
import * as actionsGlobal from '@redux/global/actions';

import { useCheckAllowEditProducts, useGetProductFullView } from 'hooks';
import { useOpenReportingResult } from 'hooks/useOpenReportingResult';
import { useCheckPermissions } from 'hooks/useCheckPermissions';
import { useFolderByLevel } from 'hooks/useFolderByLevel';

import { PERMISSION_VIEW_PRODUCT } from 'static/Permission';
import IXOneSection from 'pages/home/ribbon/components/sections/product/IXOneSection';

const ProductFullViewRibbon = ({
  isHaveAddOpenItem = true,
  productId,
  shouldShowPackaging = true,
}) => {
  const dispatch = useDispatch();
  const { keepSetting, keepResultGridPagination } = useOpenReportingResult();

  const { productFull } = useGetProductFullView({ productId });

  const hasPermissionViewProduct = useCheckPermissions(PERMISSION_VIEW_PRODUCT);

  const { checkAllowEditProductFull } = useCheckAllowEditProducts();
  const { shouldKeepFolderBreadcrumb, keepFolderBreadcrumb } =
    useFolderByLevel();

  const closeDetailCallback = () => {
    keepSetting();
    keepResultGridPagination();

    //* keep folder breadcrumb when close folder item detail
    shouldKeepFolderBreadcrumb && keepFolderBreadcrumb(true);
  };

  //* Reset not go back to members route.
  //* In case user go form member full view -> company's product.
  useEffect(() => {
    dispatch(actionsGlobal.resetProdAssetsToMember());
  }, [dispatch]);

  // const { checkInitialWorkflowQaSpecRibbon } = useInitialWorkflowQaSpec();
  // const isInitialWorkflowQaSpecRibbon = checkInitialWorkflowQaSpecRibbon();
  const isAllowEditProduct = checkAllowEditProductFull(productFull);

  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection />
      <ViewLayout disabled={true} />
      <RibbonDivider />
      <ProductDetailView productId={productId} />

      <ProductFullAction productFull={productFull} productId={productId} />

      <RibbonDivider />

      <IXOneSection isDetailView />

      {shouldShowPackaging && hasPermissionViewProduct ? (
        <ProductPackaging productFull={productFull} />
      ) : null}
      <ProductHierarchy productId={productId} />
      {isAllowEditProduct ? <Subscription productId={productId} /> : null}

      <RibbonDivider />

      <HierarchyActions productId={productId} />

      <HistorySection />

      <RibbonDivider />
      {!isAllowEditProduct && (
        <>
          <ActionsRibbonBar
            view='product-shared'
            selectedItemList={[
              { id: productFull?.ownerId, memberName: productFull?.ownerName },
            ]}
          />
          <RibbonDivider />
        </>
      )}

      <AdvanceStack isDisabled={true} />

      <OtherLayout
        ribbonSide='right'
        ribbonType='products'
        isHaveAddOpenItem={isHaveAddOpenItem}
        closeDetailCallback={closeDetailCallback}
      />
    </RibbonBar>
  );
};

export default ProductFullViewRibbon;
